<template>
  <div ref="container" @dblclick="fullscreenSwich" class="jessibuca">
    <div class="buttons-box" id="buttonsBox">
      <div class="buttons-box-left">
        <img v-if="!playing" :src="icon_play" class="jessibuca-btn" @click="playBtnClick" />
        <img v-if="playing" :src="icon_pause" class="jessibuca-btn" @click="pause" />
        <img :src="icon_stop" class="jessibuca-btn" @click="destroy" />
        <i v-if="isNotMute" class="iconfont icon-audio-high jessibuca-btn" @click="mute">关</i>
        <i v-if="!isNotMute" class="iconfont icon-audio-mute jessibuca-btn" @click="cancelMute">开</i>
      </div>
      <div class="buttons-box-right">
        <span class="jess-speed">{{ kBps }} kb/s</span>
        <img v-if="!record" :src="recordPNG" class="jessibuca-btn jessibuca-icon-record" @click="recordSwich" />
        <img v-if="record" :src="recordStopPNG" class="jessibuca-btn jessibuca-icon-recordStop" @click="recordSwich" />
        <!--          <i class="iconfont icon-file-record1 jessibuca-btn"></i>-->
        <!--          <i class="iconfont icon-xiangqing2 jessibuca-btn" ></i>-->
        <!-- <i class="iconfont icon-camera1196054easyiconnet jessibuca-btn" @click="jessibuca.screenshot('截图','png',0.5)"
           style="font-size: 1rem !important"></i> -->
        <!-- <i class="iconfont icon-shuaxin11 jessibuca-btn" @click="playBtnClick"></i> -->
        <img v-if="!fullscreen" :src="fullscreenPNG" class="jessibuca-btn" @click="fullscreenSwich" />
        <img v-if="fullscreen" :src="no_fullscreen" class="jessibuca-btn" @click="fullscreenSwich" />
      </div>
    </div>
  </div>
</template>

<script>
import { merge } from 'lodash'
import recordPNG from './../assets/record.png'
import recordStopPNG from './../assets/recordstop-default.png'
import fullscreenPNG from './../assets/fullscreen.png'
import icon_pause from './../assets/icon_pause.png'
import icon_play from './../assets/icon_play.png'
import icon_refresh from './../assets/icon_refresh.png'
import no_fullscreen from './../assets/no_fullscreen.png'
import icon_stop from './../assets/icon_stop.png'
import { compress, encodePCM, reSampleAndEncodeAudioData, aLawEncode, encodeAudioData, encodePCMA } from './../utils/encode'
// import { resolve } from '../../../lib/videoPreview.umd'

let jessibucaPlayer = {}
export default {
  name: 'jessibuca',
  data() {
    return {
      fullscreenPNG,
      recordPNG,
      recordStopPNG,
      icon_pause,
      icon_play,
      icon_stop,
      icon_refresh,
      no_fullscreen,
      playing: false,
      isNotMute: false,
      quieting: false,
      fullscreen: false,
      record: false,
      loaded: false, // mute
      speed: 0,
      performance: '', // 工作情况
      kBps: 0,
      btnDom: null,
      videoInfo: null,
      volume: 1,
      rotate: 0,
      vod: true, // 点播
      forceNoOffscreen: false,
      warpEnded: null,
      videoElement: null,
      retryCount: null,
      // 语言对讲
      audioContext: null,
      processorNode: null,
      audioSourceNode: null,
      mediaStream: null,
      dataList: [],
      websocket: null,
      wsConnected: false,
      initState:false,
    }
  },
  props: ['src', 'options', 'hasAudio', 'height'],
  mounted() {
    window.onerror = (msg) => {
      // console.error(msg)
    }
  },
    computed: {
    ratio: function () {
      // 不太可能出现这种情况，常见的音频设备采样率是 48k 44.1k
      if (!this.audioContext || this.audioContext.sampleRate < 8000) {
        return 1
      }
      return Math.floor(this.audioContext.sampleRate / 8000)
    }
  },
  watch: {
    src:{
      handler(newData, oldData) {
        this.$nextTick(()=>{
          if(newData) this.play(newData);
        })
      },
      immediate: true,
    },
  },
  methods: {
    init(src){
      // console.log('init',src);
      // if(this.initState) return;
      // this.initState = true;
      // this.play(src);
    },
    updatePlayerDomSize() {
      let dom = this.$refs.container
      let width = dom.parentNode.clientWidth
      let height = (9 / 16) * width
      const clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
      if (height > clientHeight) {
        height = clientHeight
        width = (16 / 9) * height
      }
      dom.style.width = width + 'px'
      dom.style.height = height + 'px'
    },
    create() {
      this._uid = Math.random(0,1)
      this.warpEnded = this.handleEnded.bind(this)
      const options = merge(this.defaultOptions(), this.options)
      console.warn('options =====>',this.options);
      this.retryCount = options.retryCount ? options.retryCount : 0
      jessibucaPlayer[this._uid] = new window.JessibucaPro(options)

      let jessibuca = jessibucaPlayer[this._uid]
      if (jessibuca.$container.getElementsByTagName('video').length) {
        this.videoElement = jessibuca.$container.getElementsByTagName('video')[0]
        this.videoElement.addEventListener('ended', this.warpEnded)
      }
      let _this = this

      jessibuca.on('load', function () {
        console.log('on load init')
      })
      jessibuca.on('log', function (msg) {
        console.log('on log', msg)
      })
      jessibuca.on('record', function (msg) {
        console.log('on record:', msg)
      })
      jessibuca.on('pause', function () {
        _this.playing = false
      })
      jessibuca.on('play', function () {
        _this.playing = true
      })
      jessibuca.on('fullscreen', function (msg) {
        console.log('on fullscreen', msg)
        _this.fullscreen = msg
      })
      jessibuca.on('mute', function (msg) {
        console.log('on mute', msg)
        _this.isNotMute = !msg
      })
      jessibuca.on('audioInfo', function (msg) {
        // console.log("audioInfo", msg);
      })
      jessibuca.on('videoInfo', function (msg) {
        // this.videoInfo = msg;
        console.log('videoInfo', msg)
      })
      jessibuca.on('bps', function (bps) {
        // console.log('bps', bps);
      })
      let _ts = 0
      jessibuca.on('timeUpdate', function (ts) {
        // console.log('timeUpdate,old,new,timestamp', _ts, ts, ts - _ts);
        _ts = ts
      })
      jessibuca.on('videoInfo', function (info) {
        console.log('videoInfo', info)
      })
      jessibuca.on('error', function (error) {
        console.log('error', error)
      })
      jessibuca.on('timeout', function () {
        console.log('timeout')
      })
      jessibuca.on('start', function () {
        console.log('start')
      })
      jessibuca.on("playFailedAndPaused", function (info) {  //播放失败后，没有触发任何的重播机制，就会触发这个事件
        console.log('playFailedAndPaused')
        _this.$emit('playFailedAndPaused',info)
      })
      jessibuca.on('performance', function (performance) {
        let show = '卡顿'
        if (performance === 2) {
          show = '非常流畅'
        } else if (performance === 1) {
          show = '流畅'
        }
        _this.performance = show
      })
      jessibuca.on('buffer', function (buffer) {
        // console.log('buffer', buffer);
      })
      jessibuca.on('stats', function (stats) {
        // console.log('stats', stats);
      })
      jessibuca.on('kBps', function (kBps) {
        _this.kBps = Math.round(kBps)
      })
      // 显示时间戳 PTS
      jessibuca.on('videoFrame', function () {})
      //
      jessibuca.on('metadata', function () {})
      jessibuca.on('recordBlob', res=>{this.$emit('recordBlob',res)})
      jessibuca.on("recordingTimestamp", timestamp=> {
          this.$listeners.timestampCB(timestamp)
      })
    },
    handleEnded() {
      this.videoElement && this.videoElement.removeEventListener('ended', this.warpEnded)
      if (this.src && this.retryCount > 0) {
        this.retryCount--
        this.playSrc(this.src)
      }
    },
    playBtnClick: function (event) {
      this.play(this.src)
    },
    play: async function (url) {
      console.log('jessi-play',url)
      if (jessibucaPlayer[this._uid]) {
        await this.destroy()
      }
      this.create()
      jessibucaPlayer[this._uid].on('play', () => {
        this.playing = true
        this.loaded = true
        this.quieting = window.JessibucaPro.quieting
      })
      if (jessibucaPlayer[this._uid].hasLoaded()) {
        jessibucaPlayer[this._uid].play(url)
      } else {
        jessibucaPlayer[this._uid].on('load', () => {
          console.log('load 播放')
          jessibucaPlayer[this._uid].play(url)
        })
      }
      this.cancelMute()
    },
    pause: function () {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].pause()
      }
      this.playing = false
      this.err = ''
      this.performance = ''
    },
    mute() {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].mute()
      }
    },
    cancelMute() {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].cancelMute()
      }
    },
    destroy: function () {
      return new Promise((resolve,reject)=>{
        if (jessibucaPlayer[this._uid]) {
          jessibucaPlayer[this._uid].destroy()
        }
        if (document.getElementById('buttonsBox') == null) {
          this.$refs.container.appendChild(this.btnDom)
        }
        jessibucaPlayer[this._uid] = null
        this.playing = false
        this.err = ''
        this.performance = ''
        resolve()
      })
    },
    async dispose(){
      return await this.destroy();
    },
    eventcallbacK: function (type, message) {
      // console.log("player 事件回调")
      // console.log(type)
      // console.log(message)
    },
    fullscreenSwich: function () {
      let isFull = this.isFullscreen()
      jessibucaPlayer[this._uid].setFullscreen(!isFull)
      this.fullscreen = !isFull
    },
    recordSwich: function () {
      if(!this.record){
        jessibucaPlayer[this._uid].startRecord()
      }else{
        if(this.options?.returnBlob){
          jessibucaPlayer[this._uid].stopRecordAndSave('blob')
        }else{
          jessibucaPlayer[this._uid].stopRecordAndSave()
        }
      }
      this.record = !this.record
      this.$listeners.recordCB(this.record)  //同recordBlob
    },
    isFullscreen: function () {
      return document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || false
    },
    defaultOptions() {
      return {
        // container: this.$refs.container,
        // // videoBuffer: 0.2, // 最大缓冲时长，单位秒
        // videoBuffer: 2, // 最大缓冲时长，单位秒
        // isResize: true,
        // decoder: '/public/vendors/iot/decoder-pro.js',
        // useMSE: true,
        // showBandwidth: false,
        // isFlv: true,
        // // text: "WVP-PRO",
        // // background: "static/images/zlm-logo.png",
        // loadingText: '加载中',
        // hasAudio: typeof this.hasAudio == 'undefined' ? true : this.hasAudio,
        // debug: false,
        // supportDblclickFullscreen: false, // 是否支持屏幕的双击事件，触发全屏，取消全屏事件。
        // operateBtns: {
        //   fullscreen: false,
        //   screenshot: false,
        //   play: false,
        //   audio: false,
        //   recorder: false
        // },
        // record: 'record',
        // vod: this.vod,
        // forceNoOffscreen: this.forceNoOffscreen,
        // isNotMute: this.isNotMute,
        // videoElementPlayingFailedReplay:true,
        // networkDelayTimeoutReplay:true,
        // loadingTimeoutReplay:true,
        // autoWasm:true, //自动降级到 wasm 模式
        container: this.$refs.container,
        videoBuffer: 0.3, // 最大缓冲时长，单位秒
        videoBufferDelay:1,
        isResize: true,
        decoder: `${window.deployBaseRoute || '/'}public/vendors/iot/decoder-pro.js`,
        // decoder: '../thirdparty/jessibuca/decoder-pro.js', //to wuyou
        useMSE: true,
        autoWasm:true, //自动降级到 wasm 模式
        useSIMD:true,// 硬解码不支持的时候，优先降级到simd 解码
        isFlv: true,
        record: 'record',
        // text: "WVP-PRO",
        // background: "static/images/zlm-logo.png",
        loadingText: '加载中',
        hasAudio: typeof this.hasAudio == 'undefined' ? true : this.hasAudio,
        debug: true,
        debugLevel:'debug',
        isNotMute: this.isNotMute,
        networkDelayTimeoutReplay:true, // 配置网络抖动超时后是否重试播放
        networkDelay:10, // 单位秒：网络延迟多少秒后重连(自己根据业务需求设置)
        replayUseLastFrameShow: true, // 重播使用上一帧显示
        replayShowLoadingIcon: false,// 重播显示loading
        decoderErrorAutoWasm: false, // 解码失败自动降级到 wasm 模式
        supportHls265: true, //选择hls265解码器
      }
    },
    // 语音对讲
    async startVoice(webSrc) {
      console.log('语音对讲')
      this.websocket = new WebSocket(webSrc)
      this.websocket.onopen = this.onWebSocketOpen
      this.websocket.onclose = this.onWebSocketClose
      this.websocket.onerror = this.onWebSocketError
      this.mediaStream = await this.getMediaStream()

      await this.makeAudioContextRunning()
      try {
        this.audioSourceNode = this.audioContext.createMediaStreamSource(this.mediaStream)

        // console.log(this.audioContext, this.mediaStream, this.audioSourceNode)

        // 只采集单声道方便处理数据
        this.processorNode = this.audioContext.createScriptProcessor(4096, 1, 1)
        this.audioSourceNode.connect(this.processorNode)
        // sampleRate = 8k & bufferSize = 4096 => 每 0.512s 触发一次 onaudioprocess
        this.processorNode.onaudioprocess = this.onAudioProcess

        this.processorNode.connect(this.audioContext.destination)
      } catch (e) {
        throw new Error('您的浏览器音频相关接口异常，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }
    },
    stopVoice() {
      console.log('stop')
      if (this.dataList.length) {
        this.sendAudioData(this.dataList)
        this.dataList = []
      }
      this.releaseResources()
    },
        getMediaStream() {
      // 大部分浏览器有安全限制，http 协议访问的页面 navigator.mediaDevices 也是 undefined， 仅提供 https 服务的可以忽略这个问题
      if (!navigator.mediaDevices) {
        return Promise.reject('您的浏览器不支持获取用户设备，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }
      return navigator.mediaDevices
        .getUserMedia({ audio: { sampleRate: 8000 } })
        .catch(() => Promise.reject('请确保录音设备正常，并允许浏览器获取录音权限，否则无法使用对讲功能'))
    },
       onAudioProcess(event) {
      const lData = event.inputBuffer.getChannelData(0)
      // var l = channelData.length;
      // var buf = new Int16Array(l)

      // while (l--) {
      //     buf[l] = channelData[l]*0xFFFF;    //convert to 16 bit
      // }

      aLawEncode

      encodePCM
      encodePCMA
      encodeAudioData
      // PCMA
      if (this.wsConnected) {
        this.websocket.send(
          encodeAudioData(
            compress(
              {
                left: lData,
                right: []
              },
              48000,
              8000
            )
          )
        )
      }

      return
    },
        async makeAudioContextRunning() {
      // 一般不会出现这种情况，以防万一
      if (!this.audioContext || this.audioContext.state === 'closed') {
        this.audioContext = new AudioContext({
          sampleRate: 8000,
          latencyHint: 'interactive'
        })
      }
      if (this.audioContext.state === 'suspended') {
        await this.audioContext.resume()
      }
    },
    
    releaseResources() {
      if (this.audioSourceNode) {
        this.audioSourceNode.disconnect()
      }
      if (this.processorNode) {
        this.processorNode.disconnect()
      }
      if (this.mediaStream) {
        this.mediaStream.getAudioTracks().forEach((track) => track.stop())
      }
    },
       sendAudioData(dataList) {
      const base64Audio = reSampleAndEncodeAudioData(dataList, 4096, this.ratio)
      // console.log('base64Audio', base64Audio)
      if (this.wsConnected) {
        this.websocket.send(base64Audio)
      }
      // console.log(base64Audio)
    },
        onWebSocketOpen() {
      this.wsConnected = true
    },
    onWebSocketClose() {
      this.wsConnected = false
    },
        onWebSocketError(e) {
      console.error(e)
      this.wsConnected = false
    },
  },
  destroyed() {
    if (jessibucaPlayer[this._uid]) {
      jessibucaPlayer[this._uid].destroy()
    }
    this.playing = false
    this.loaded = false
    this.performance = ''
  }
}
</script>

<style lang="scss" scoped>
.jessibuca {
  width: 100%;
  height: 100%;
  background: #000;
  .buttons-box {
    width: 100%;
    height: 28px;
    background-color: rgba(43, 51, 63, 0.7);
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    left: 0;
    bottom: 0;
    user-select: none;
    z-index: 10;
    justify-content: space-between;
  }
  .jessibuca-btn {
    width: 20px;
    color: rgb(255, 255, 255);
    line-height: 27px;
    margin: 0px 10px;
    padding: 0px 2px;
    cursor: pointer;
    text-align: center;
    font-size: 0.8rem !important;
  }
  .jessibuca-icon-record{
    width: 20px;
  }
  .jessibuca-icon-recordStop{
    width: 18px;
       background: url("../assets/recordstop-default.png") no-repeat center;
        background-size: 100% 100%;

        &:hover {
            background: url("../assets/recordStop.png") no-repeat center;
            background-size: 100% 100%;
        }
  }
  .buttons-box-left {
    display: flex;
    align-items: center;
  }
  .buttons-box-right {
    display: flex;
    align-items: center;
    .jess-speed {
      color: #fff;
      font-size: 14px;
    }
  }
}
</style>
